/**
 * Clears all cookies for the current domain
 * This should be used when logging out or when needing to clear authentication state
 */
export const clearAllCookies = (): void => {
  // Get all cookies
  const cookies = document.cookie.split(';');
  
  // Clear each cookie by setting it to expire in the past
  for (const cookie of cookies) {
    const [name] = cookie.split('=');
    if (name.trim()) {
      // Set expiration to past date and clear the value
      document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure`;
      
      // Also try with domain attribute to ensure subdomain cookies are cleared
      document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}; secure`;
      
      // Try with parent domain in case it's set at a higher level
      const domainParts = window.location.hostname.split('.');
      if (domainParts.length > 2) {
        const parentDomain = domainParts.slice(domainParts.length - 2).join('.');
        document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${parentDomain}; secure`;
      }
    }
  }
};
